module.exports = __webpack_public_path__ + "static/media/screen7.a70ae395.png";